import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { GetProtectedValueNotesResponseInterface } from '../definitions/get-protected-value-notes-response.interface';

@Injectable()
export class GetProtectedValueNotesService {
    constructor(private client: HttpClient, private configService: ConfigService) {}
  
    public getNotes(): Observable<Array<GetProtectedValueNotesResponseInterface>> {
      const url = `${this.configService.config.rest.apiV2Url}/protected-values/notes`;
  
      return this.client.get<Array<GetProtectedValueNotesResponseInterface>>(url).pipe(
        catchError(error => throwError(handleProblem(error)))
      );
    }
}